export default function Hero() {
  return (
    <section
      id="hero"
      className="
        grid grid-cols-1 md:grid-cols-2
        gap-5 md:gap-10
        px-6 py-8 md:p-12
        items-center
      "
    >
      {/* LEFT SIDE */}
      <div>
        <div className="flex justify-between items-center gap-4">
          <h1 className="text-4xl md:text-8xl font-serifDisplay font-medium italic leading-tight">
            Dr Harvey <br />
            <span>C. Kwiyani</span>
          </h1>

          {/* Mobile image only */}
          <img
            src="/images/harveykwiyanihero.png"
            alt="Harvey Kwiyani"
            className="
              block md:hidden
              w-1/3 h-24
              rounded-xl
              object-cover
            "
          />
        </div>

        {/* Tags */}
        <div
          className="
            mt-4 md:mt-6
            flex flex-wrap
            gap-2 md:gap-4
            justify-center md:justify-start
          "
        >
          <button className="border px-3 py-1.5 md:px-4 md:py-2 border-[#D07728] rounded-lg font-medium text-[#3B5E4C] text-sm md:text-base">
            Missiologist
          </button>

          <button className="border px-3 py-1.5 md:px-4 md:py-2 border-[#D07728] rounded-lg font-medium text-[#3B5E4C] text-sm md:text-base">
            Author
          </button>

          <button className="border px-3 py-1.5 md:px-4 md:py-2 border-[#D07728] rounded-lg font-medium text-[#3B5E4C] text-sm md:text-base">
            Speaker
          </button>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div>
        {/* Desktop image only */}
        <img
          src="/images/harveykwiyanihero.png"
          alt="Harvey Kwiyani"
          className="hidden md:block w-full h-100 rounded-sm object-cover"
        />

        <p
          className="
            md:mt-6
            text-base md:text-lg
            leading-relaxed
            w-full
            text-center md:text-right
          "
        >
          I believe mission must be reimagined beyond Western dominance;
          amplifying African voices in the global story of faith, culture,
          and mission.
        </p>
      </div>
    </section>
  );
}